module.exports = __webpack_public_path__ + "static/media/moviebuff_tm.89027249.png";